export const removeDecimals = (number: number) => Number(number.toFixed(0));
